__turbopack_context__.v({
  "architecture": "Architecture-module-scss-module___F-hqG__architecture",
  "architectureBottom": "Architecture-module-scss-module___F-hqG__architectureBottom",
  "bg": "Architecture-module-scss-module___F-hqG__bg",
  "descriptionBox": "Architecture-module-scss-module___F-hqG__descriptionBox",
  "descriptionBox__leftBottom": "Architecture-module-scss-module___F-hqG__descriptionBox__leftBottom",
  "descriptionBox__leftTop": "Architecture-module-scss-module___F-hqG__descriptionBox__leftTop",
  "descriptionBox__rightMiddle": "Architecture-module-scss-module___F-hqG__descriptionBox__rightMiddle",
  "descriptionBox__text": "Architecture-module-scss-module___F-hqG__descriptionBox__text",
  "firstBox": "Architecture-module-scss-module___F-hqG__firstBox",
  "firstLine": "Architecture-module-scss-module___F-hqG__firstLine",
  "firstScreenContainer": "Architecture-module-scss-module___F-hqG__firstScreenContainer",
  "firstScreenSvg": "Architecture-module-scss-module___F-hqG__firstScreenSvg",
  "fourthLine": "Architecture-module-scss-module___F-hqG__fourthLine",
  "gradient": "Architecture-module-scss-module___F-hqG__gradient",
  "gradient__leftBottom": "Architecture-module-scss-module___F-hqG__gradient__leftBottom",
  "gradient__leftTop": "Architecture-module-scss-module___F-hqG__gradient__leftTop",
  "gradient__rightMiddle": "Architecture-module-scss-module___F-hqG__gradient__rightMiddle",
  "header": "Architecture-module-scss-module___F-hqG__header",
  "imageContainerKamen": "Architecture-module-scss-module___F-hqG__imageContainerKamen",
  "img": "Architecture-module-scss-module___F-hqG__img",
  "kamen": "Architecture-module-scss-module___F-hqG__kamen",
  "mainText": "Architecture-module-scss-module___F-hqG__mainText",
  "secondLine": "Architecture-module-scss-module___F-hqG__secondLine",
  "text": "Architecture-module-scss-module___F-hqG__text",
  "textBox": "Architecture-module-scss-module___F-hqG__textBox",
  "title": "Architecture-module-scss-module___F-hqG__title",
  "whiteSpace": "Architecture-module-scss-module___F-hqG__whiteSpace",
});
